export default "__VITE_ASSET__D2HxBAU1__"